import script from "./FiltersDropdownsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersDropdownsList.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersDropdownsList.vue?vue&type=style&index=0&id=3faf95d8&lang=css"

const __exports__ = script;

export default __exports__